<template>
<!-- <<<<<<< HEAD -->
  <!-- <div class="account">
      <el-steps :space="200" :active="activeIndex" finish-status="success" class="accountSteps">
        <el-step v-for="(item,index) in stepsList" :key="index" :title="item.name"></el-step>
      </el-steps>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="130px"
      class="accountruleForm"
    >
      <div class="accountTitle">
        <h4>个人信息</h4>
      </div>
      <div class="designerID flex">
        <div class="designerIDmes">
          <el-form-item prop="idCarZ" class="idCarZ">
            <el-upload
              action="/service-center/upload/file/single"
              :on-success="handleAvatarSuccess"
              class="hiddenInput"
              :headers="headers"
              :before-upload="beforeAvatarUpload"
              :show-file-list="false"
            >
              <img :src="userInfo.avatar" alt="" /> -->
              <!-- <img src="backUrl" alt="" /> -->
            <!-- </el-upload>
            <p>支持PNG、JPG大小不超过1MB</p>
          </el-form-item>
        </div>
        <div class="designerIDmes">
          <el-form-item prop="idCarB">
            <el-upload
              action="/service-center/upload/file/single"
              :before-upload="beforeAvatarUpload"
              :headers="headers"
              :on-success="handleAvatarSuccess2"
              class="hiddenInput2"
              :show-file-list="false"
            >
              <img :src="userInfo2.avatar" alt="" /> -->
              <!-- <img v-if="frontUrl" :src="frontUrl" alt="" /> -->
           <!-- </el-upload>
            <p>支持PNG、JPG大小不超过1MB</p>
          </el-form-item>
        </div>
      </div>
      <el-row>
        <el-col :span="12">
          <el-form-item label="姓名" prop="name">
            <el-input
              v-model="ruleForm.name"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="证件号码" prop="idCard">
            <el-input
              v-model="ruleForm.idCard"
              placeholder="请输入证件号码"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="地址" prop="address">
            <el-select v-model="ruleForm.address" placeholder="省/市/区">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="详细地址" prop="addressDetails">
            <el-input
              v-model="ruleForm.addressDetails"
              placeholder="请输入详细地址"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="accountTitle">
        <h4>结算信息</h4>
      </div>
      <el-form-item label="银行账户类型" prop="bankType">
        <el-select v-model="ruleForm.bankType" placeholder="请选择银行账户类型">
          <el-option label="区域一" value="shanghai"></el-option>
          <el-option label="区域二" value="beijing"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开户行" prop="openBank">
        <el-select v-model="ruleForm.openBank" placeholder="请选择开户行">
          <el-option label="区域一" value="shanghai"></el-option>
          <el-option label="区域二" value="beijing"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="银行账户号码" prop="bankNumber">
        <el-input
          v-model="ruleForm.bankNumber"
          placeholder="请输入银行账户号码"
        ></el-input>
      </el-form-item>
      <el-form-item  prop="activeStatus" v-if="activeIndex != 4">
          <div class="activeStatus_btn" :style="{background:ruleForm.status==4?'red':'#3d7fff'}">
            {{ruleForm.status==0?'审核中':ruleForm.status==1?'真实性验证中':ruleForm.status==2?'业务开通中':ruleForm.status==3?'申请已完成':ruleForm.status==4?'审核失败':''}}
          </div>
            <div v-if="ruleForm.status === 4">审核意见：{{ruleForm.result}}</div>
      </el-form-item> -->

      <!-- <el-form-item class="formBtn">
        <el-button @click="resetForm('ruleForm')">取消</el-button>
        <el-button type="primary" v-if="ruleForm.status==4">编辑</el-button >
        <el-button  v-if="ruleForm.status!=4" :type="primary" @click="submitForm('ruleForm')"
          >提交</el-button >
      </el-form-item>
      <el-form-item class="formBtn" v-if="activeIndex==4">
        <el-button>请点击前往签署入户协议 >>></el-button>
      </el-form-item>
    </el-form>
  </div> -->
<!-- ======= -->
    <div class="account">
        <el-steps :space="200" :active="activeIndex" align-center finish-status="success" class="accountSteps">
            <el-step v-for="(item,index) in stepsList" :key="index" :title="item.name"></el-step>
        </el-steps>
        <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="130px"
            class="accountruleForm"
        >
        <!-- v-if="applicationStatus == 'COMPLETED'" -->
            <div class="previewImgBox" v-if="applicationStatus == 'COMPLETED'" >
                <div @click="previewImg">  微信支付开通：点击扫描支付二维码进行微信支付认证！</div>
                <el-image
                    ref="previewImg"
                    style="width: 0; height: 0;display:none"
                    :src="srcList[0]"
                    :preview-src-list="srcList">
                </el-image>
            </div>
            <div class="accountTitle">
                <h4>个人信息</h4>
            </div>
            <div class="designerID flex">
                <div class="designerIDmes">
                    <el-form-item prop="idCarZ" class="idCarZ">
                        <el-upload :disabled="isSettled"
                            action="/service-center/upload/file/single"
                            :on-success="handleAvatarSuccess"
                            class="hiddenInput"
                            :headers="headers"
                            :before-upload="beforeAvatarUpload"
                            :show-file-list="false"
                        >
                            <img v-if="ruleForm.frontUrl" :src="ruleForm.frontUrl" alt=""/>
                            <img v-else :src="userInfo.avatar" alt=""/>
                        </el-upload>
                        <p>支持PNG、JPG大小不超过1MB</p>
                    </el-form-item>
                </div>
                <div class="designerIDmes">
                    <el-form-item prop="idCarB">
                        <el-upload :disabled="isSettled"
                            action="/service-center/upload/file/single"
                            :before-upload="beforeAvatarUpload"
                            :headers="headers"
                            :on-success="handleAvatarSuccess2"
                            class="hiddenInput2"
                            :show-file-list="false"
                        >
                            <img v-if="ruleForm.backUrl" :src="ruleForm.backUrl" alt=""/>
                            <img v-else :src="userInfo.avatar" alt=""/>
                        </el-upload>
                        <p>支持PNG、JPG大小不超过1MB</p>
                    </el-form-item>
                </div>
            </div>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="姓名" prop="name">
                        <el-input
                            v-model="ruleForm.name"
                            placeholder="请输入姓名" :disabled="isSettled"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="证件号码" prop="legalLicenceNo">
                        <el-input
                            v-model="ruleForm.legalLicenceNo"
                            placeholder="请输入证件号码" :disabled="isSettled"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="地区" prop="district">
                        <el-cascader placeholder="省/市/区"
                                     v-model="ruleForm.district"
                                     :options="provinceData"
                                     @change="handleChange"
                                     class="cascaderInput" :disabled="isSettled"
                        ></el-cascader>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="详细地址" prop="address">
                        <el-input
                            v-model="ruleForm.address"
                            placeholder="请输入详细地址" :disabled="isSettled"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="手机号" prop="mobile">
                        <el-input
                            v-model="ruleForm.mobile"
                            placeholder="请输入手机号码" :disabled="isSettled"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="accountTitle">
                <h4>结算信息</h4>
            </div>
            <el-form-item label="银行账户类型" prop="bankAccountType">
                <el-select v-model="ruleForm.bankAccountType" placeholder="请选择银行账户类型" :disabled="isSettled">
                    <el-option label="借记卡" value="DEBIT_CARD"></el-option>
                    <el-option label="存折" value="PASSBOOK"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="开户行" prop="bankCode">
                <el-select v-model="ruleForm.bankCode" placeholder="请选择开户行" filterable :disabled="isSettled">
                    <el-option v-for="item in bankData" :key="item.code" :label="item.value" :value="item.code" />
                </el-select>
            </el-form-item>
            <el-form-item label="银行账户号码" prop="bankCardNo">
                <el-input type="number"
                    v-model="ruleForm.bankCardNo"
                    placeholder="请输入银行账户号码" :disabled="isSettled"
                ></el-input>
            </el-form-item>
            <el-form-item  prop="activeStatus" v-if="activeIndex != 4">
                <div class="activeStatus_btn" :style="{background:ruleForm.status==5?'red':'#3d7fff'}" v-if="ruleForm.status !== -1">
                    {{ruleForm.status==0?'审核中':ruleForm.status==1?'真实性验证中':ruleForm.status==2?'业务开通中':ruleForm.status==3?'协议待签署':ruleForm.status==4?'申请已完成':ruleForm.status==5?'审核退回':''}}
                </div>
                <div v-if="ruleForm.status === 5">审核意见：{{ruleForm.result}}</div>
            </el-form-item>
            <el-form-item class="formBtn">
                <el-button v-if="!isSettled" @click="resetForm('ruleForm')">取消</el-button>
                <el-button type="primary"v-if="ruleForm.status==5 && isSettled" @click="edit">编辑</el-button >
                <el-button  v-if="!isSettled" type="primary" @click="submitForm('ruleForm')"
                >提交</el-button >
            </el-form-item>
            <el-form-item class="formBtn" v-if="activeIndex==4">
                <el-button>请点击前往签署入户协议 >>></el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import {getCredentials, getNewcurrent, getMerchantInfo, merchantApply} from "../../utils/interface";
    import provinceData from "../../utils/area";
    import bankData from "../../utils/bankData";
    export default {
        data() {
            return {
                applicationStatus: '',
                srcList: [
                    require('@/assets/images/Wechat.jpeg')
                ],
                //步骤条
                stepsList:[
                    {name:'开户申请'},
                    {name:'审核中'},
                    {name:'真实性验证中'},
                    {name:'协议待签署'},
                    {name:'业务开通中'},
                    {name:'已通过'},
                ],
                activeIndex:1,
                headers: {
                    Authorization: "Bearer " + this.$cookies.get("api_access_token"), //	可以是授权凭证用的参数值
                },
                ruleForm: {
                    idCarZ: "",
                    idCarB: "",
                    name: "",
                    legalLicenceNo: "",
                    mobile: "",
                    province: "",
                    city: "",
                    district: "",
                    address: "",
                    bankAccountType: "",
                    bankCode: "",
                    bankCardNo: "",
                    status:0,
                },
                provinceData: provinceData,
                bankData: bankData,
                rules: {
                    name: [{required: true, message: "请输入姓名", trigger: "blur"}],
                    mobile: [
                        {required: true, message: "请输入手机号码", trigger: "blur"},
                        {
                            pattern: /^[1][3-9]\d{9}$/,
                            message: '请输入正确的手机号码',
                        },
                    ],
                    legalLicenceNo: [
                        {required: true, message: "请输入证件号码", trigger: "blur"},
                    ],
                    district: [
                        {required: true, message: "请选择省/市/区", trigger: "change"},
                    ],
                    address: [
                        {required: true, message: "请输入详细地址", trigger: "blur"},
                    ],
                    bankAccountType: [
                        {required: true, message: "请选择银行账户类型", trigger: "change"},
                    ],
                    bankCode: [
                        {required: true, message: "请选择开户行", trigger: "change"},
                    ],
                    bankCardNo: [
                        {required: true, message: "请输入银行账户号码", trigger: "blur"},
                    ],
                },
                // 上传身份证
                userInfo: {
                    avatar: require("../../assets/images/idCarP.png"),
                },
                userInfo2: {
                    avatar: require("../../assets/images/idCarC.png"),
                },
                userMessages: {},
                merchantInfo: {
                    accountInfo: {
                        bankAccountType: "",
                        bankCardNo: "",
                        bankCode: ""
                    },
                    applyType: "PERSONAL",
                    businessAddressInfo: {
                        address: "",
                        city: "",
                        district: "",
                        province: ""
                    },
                    merchantCorporationInfo: {
                        backUrl: "",
                        frontUrl: "",
                        legalLicenceNo: "",
                        legalLicenceType: "ID_CARD",
                        mobile: ""
                    },
                    merchantSubjectInfo: {
                        shortName: "",
                        signName: ""
                    }
                },
                isSettled: false,
                settledInfo: {},
            };
        },
        mounted(){
            console.log('ruleForm.status',this.ruleForm.status );
            getMerchantInfo().then((res) => {
                // console.log("入驻信息详情"+JSON.stringify(res))
                if(res && res.success){
                    this.applicationStatus = res.data.applicationStatus
                    this.settledInfo = res.data;
                    this.ruleForm.bankAccountType = res.data.accountInfo.bankAccountType;
                    this.ruleForm.bankCardNo = res.data.accountInfo.bankCardNo;
                    this.ruleForm.bankCode = res.data.accountInfo.bankCode;

                    this.ruleForm.address = res.data.businessAddressInfo.address;
                    this.ruleForm.city = res.data.businessAddressInfo.city;
                    this.ruleForm.district = res.data.businessAddressInfo.district;
                    this.ruleForm.province = res.data.businessAddressInfo.province;

                    this.ruleForm.frontUrl = res.data.merchantCorporationInfo.frontUrl;
                    this.ruleForm.backUrl = res.data.merchantCorporationInfo.backUrl;
                    this.ruleForm.legalLicenceNo = res.data.merchantCorporationInfo.legalLicenceNo;
                    this.ruleForm.mobile = res.data.merchantCorporationInfo.mobile;
                    this.ruleForm.name = res.data.merchantSubjectInfo.signName;

                    if(res.data.applicationStatus == 'REVIEW_BACK'){
                        this.ruleForm.result = res.data.auditOpinion;
                        this.ruleForm.status = 5;
                        this.activeIndex = 2;
                        this.isSettled = true;
                    } else if(res.data.applicationStatus == 'REVIEWING'){
                        this.ruleForm.status = 0;
                        this.activeIndex = 2;
                        this.isSettled = true;
                    } else if(res.data.applicationStatus == 'AUTHENTICITY_VERIFYING'){
                        this.ruleForm.status = 1;
                        this.activeIndex = 3;
                        this.isSettled = true;
                    }else if(res.data.applicationStatus == 'AGREEMENT_SIGNING'){
                        this.ruleForm.status = 3;
                        this.activeIndex = 4;
                        this.isSettled = true;
                    }else if(res.data.applicationStatus == 'BUSINESS_OPENING'){
                        this.ruleForm.status = 2;
                        this.activeIndex = 5;
                        this.isSettled = true;
                    } else if(res.data.applicationStatus == 'COMPLETED'){
                        this.ruleForm.status = 4;
                        this.activeIndex = 6;
                        this.isSettled = true;
                    } else{
                        this.activeIndex = 0;
                        this.isSettled = false;
                    }
                }else{
                    getNewcurrent()
                        .then((res) => {
                            this.userMessages = res;
                            this.ruleForm.name = this.$store.state.userMessages.name;
                            this.ruleForm.backUrl = this.$store.state.userMessages.frontUrl;
                            this.ruleForm.frontUrl = this.$store.state.userMessages.backUrl;
                            this.ruleForm.legalLicenceNo = this.$store.state.userMessages.idCard;
                            this.ruleForm.mobile = this.$store.state.userMessages.tel;
                            this.isSettled = false;
                            this.ruleForm.status = -1
                            this.activeIndex = 0;
                        })
                        .catch((err) => {
                            console.log(err);
                        });

                }
            })

        },
        methods: {
            // 点击预览图片
            previewImg(){
                this.$refs.previewImg.showViewer = true
            },
            edit(){
                this.isSettled=false
                this.ruleForm.status = -1;
            },
            // 地区选择
            handleChange(value) {
                if (value != null && value.length === 3) {
                    this.ruleForm.province = value[0] + '000'
                    this.ruleForm.city = value[1] + '00'
                    this.ruleForm.district = value[2]
                } else if (value != null && value.length === 2) {
                    this.ruleForm.province = value[0] + '000'
                    this.ruleForm.city = value[1] + '00'
                    this.ruleForm.district = value[1]
                }
                // console.log(this.ruleForm)
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.merchantInfo.accountInfo.bankAccountType = this.ruleForm.bankAccountType;
                        this.merchantInfo.accountInfo.bankCardNo = this.ruleForm.bankCardNo;
                        this.merchantInfo.accountInfo.bankCode = this.ruleForm.bankCode;

                        this.merchantInfo.businessAddressInfo.address = this.ruleForm.address;
                        this.merchantInfo.businessAddressInfo.city = this.ruleForm.city;
                        this.merchantInfo.businessAddressInfo.district = this.ruleForm.district;
                        this.merchantInfo.businessAddressInfo.province = this.ruleForm.province;

                        this.merchantInfo.merchantCorporationInfo.backUrl = this.ruleForm.backUrl;
                        this.merchantInfo.merchantCorporationInfo.frontUrl = this.ruleForm.frontUrl;
                        this.merchantInfo.merchantCorporationInfo.legalLicenceNo = this.ruleForm.legalLicenceNo;
                        this.merchantInfo.merchantCorporationInfo.mobile = this.ruleForm.mobile;

                        this.merchantInfo.merchantSubjectInfo.shortName = this.ruleForm.name;
                        this.merchantInfo.merchantSubjectInfo.signName = this.ruleForm.name;
                        // console.log(this.merchantInfo);
                        merchantApply(this.merchantInfo).then((res)=>{
                            // console.log(res);
                            this.isSettled = true;
                            this.ruleForm.status = 0;
                            this.$message({
                                type: "success",
                                message: "开户信息提交成功！",
                            });
                        });
                    } else {
                        console.log("error submit!!");
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            // 校验图片
            beforeAvatarUpload(file) {
                let fileTypes = [".jpg", ".png", ".jpeg", ".JPG", ".PNG", ".JPEG"];
                let fileName = file.name.lastIndexOf(".");
                const fileNameLen = file.name.length;
                const fileTypeName = file.name.substring(fileName, fileNameLen);
                let fileIndex = fileTypes.indexOf(fileTypeName);
                const isLt1M = file.size / 1024 / 1024 < 1;
                if (!isLt1M) {
                    this.$message.error("上传图片大小不能超过 1MB!");
                }
                if (fileIndex === -1) {
                    this.$alert("只能上传图片格式", "提示", {
                        confirmButtonText: "确定",
                    });
                }
                return fileIndex !== -1 && isLt1M;
            },
            handleAvatarSuccess(file) {
                // console.log(file.url);
                this.ruleForm.frontUrl = file.url;
                this.$forceUpdate();
            },
            handleAvatarSuccess2(file) {
                this.ruleForm.backUrl = file.url;
                this.$forceUpdate();
            },
        },
    };
</script>

<style lang="less" scoped>
    .designerID {
        margin: 23px 0 34px;

        .designerIDmes {
            margin-right: 142px;
            text-align: center;

            img {
                width: 271px;
                height: 169px;
                margin-bottom: 6px;
                border-radius: 22px;
            }

            p {
                font-size: 12px;
                color: #c6c6c6;
            }
        }
    }
  /deep/.el-step__line{
                top: 45% !important;
            }
    .accountSteps{
        width: 67%;
        margin: 30px auto;
        /deep/.el-step__icon{
            width: 60px;
            height: 60px;
        }


        /deep/.is-success{
            color: #3d7fff;
            border-color:#3d7fff;
        }

    }

    .accountruleForm {
        width: 60%;
        margin: 30px auto;
        .accountTitle {
            margin: 20px 0;
            border-bottom: 1px solid #efefef;
            h4 {
                border-bottom: 3px solid #3d7fff;
                color: #3d7fff;
                width: 68px;
                padding-bottom: 5px;
                margin: 0;
            }
        }
        /deep/.el-select {
            width: 100%;
        }
        .formBtn {
            margin-top: 80px;
        }
        .designerID {
            display: flex;
            .hiddenInput {
                img {
                    width: 271px;
                    height: 169px;
                }
            }
        }
        .idCarZ {
            /deep/.el-form-item__content {
                margin: 0 !important;
            }
        }
        .activeStatus_btn{
            width: 100px;
            height: 40px;
            color: #fff;
            border-radius: 5px;
            text-align: center;
            line-height: 40px;

        }
    }
.previewImgBox {
    cursor: pointer;
    color: #e51313;
    font-size: 14px;
    font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/views/settlement/accountManagement.vue